import type { ToastServiceMethods } from 'primevue/toastservice'

let _toast: ToastServiceMethods | null = null

export const setToast = (toast: ToastServiceMethods) => {
    _toast = toast
}

export const PrintSuccess = (message: string) => {
    _toast?.add({ severity: 'success', summary: message, life: 3000 })
}

export const PrintError = (message: string) => {
    _toast?.add({ severity: 'error', summary: message, life: 5000 })
}
